import { Card, Pad, PadBox, Separator } from "component/basics";
import { LoadingScreen } from "component/banner";
import { Heading } from "component/text";
import { useDatastore, usePersonaKey } from "util/datastore";
import { useEffect, useState } from "react";
import { ArticleCard } from "structure/question";
import type { RelatedArticle } from "open-modules/cbcrc/feature/topic/editorial-reading-list";

type RecommendedArticle = RelatedArticle & { tags?: string[] };
import type { Feature } from "util/stdtypes";
import type { ProfileConfig } from "structure/profile";

export const ProfileArticleRecommendationsFeature: Feature<ProfileConfig, {}> = {
    name: 'Article Recommendations',
    key: 'profilearticlerecommendations',
    providesConfig: {
        profileWidgets: [ProfileArticleRecommendationWidget]
    }
};

export function ProfileArticleRecommendationWidget(): JSX.Element {
    return <ProfileArticleRecommendationBox></ProfileArticleRecommendationBox>
}

export function ProfileArticleRecommendationBox(): JSX.Element {

    const datastore = useDatastore();
    const myInterests = datastore.getGlobalProperty("interests")
    const personaKey = usePersonaKey();

    const [loaded, setLoaded] = useState(false);
    const [articles, setArticles] = useState<RecommendedArticle[]>([]);

    useEffect(() => {
        async function fetchArticles(){
            const loadedArticles = await datastore.callServerAsync(
                'interests', 'getInterestingArticles', {
                    type: "article", personaKey: personaKey
                });
            setArticles(loadedArticles)
            setLoaded(true)
        }
        fetchArticles()
        
        
    },[])

    if(!loaded){
        return <LoadingScreen></LoadingScreen>
    }

    if(!articles || articles.length === 0){
        return <></>
    }


    return <Card>
        <Separator></Separator>
        <Pad></Pad>
        <Heading label={"These articles might interest you:"}></Heading>
        {articles.map( article => (
            <PadBox vert={4} key={"recommended-article-" + article.key}>
                <ArticleCard article={article} tags={article.tags} key={article.key}/>
            </PadBox>
        ))}

    </Card>
    
}
